import styled from "styled-components";

export const StyledCompletableTask = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  align-items: center;
  cursor: pointer;
`;

export const StyledCompletableTaskIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  pointer-events: none;
  user-select: none;
  -webkit-touch-callout: none;

  border: ${({ $percentage }) =>
    $percentage === 100 ? "5px solid darkslategray" : "1px solid darkgray"};
  color: white;

  position: relative;

  &::after {
    content: "a";
    color: transparent;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    border-radius: 50%;
    background: linear-gradient(
      to right,
      ${({ $percentage }) =>
        "#00C851 0%, #00C851 " +
        $percentage +
        "%, transparent " +
        $percentage +
        "%, transparent " +
        (100 - $percentage) +
        "%"}
    );
  }
`;

export const StyledCompletableTaskIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  z-index: 2;
`;

export const StyledTaskTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  text-overflow: ellipsis;
  word-wrap: break-word;
  word-break: whitespace;
  max-width: 100px;
  text-align: center;
  position: relative;
`;

export const StyledCompletableTaskBarWrapper = styled.div`
  padding: 14px;
  border-radius: ${({ $percentage }) => ($percentage === 100 ? "13px" : "8px")};
  margin: ${({ $percentage }) => ($percentage === 100 ? "0px" : "4px")};
  border: ${({ $percentage, theme }) =>
    $percentage === 100
      ? `5px solid ${theme.border}`
      : `1px solid ${theme.border}`};
  pointer-events: none;
  user-select: none;
  -webkit-touch-callout: none;
  ${(p) => (p.$fullWidth ? "width: 100%" : "")};

  & > * {
    z-index: 1;
    position: relative;
  }

  position: relative;

  &::after {
    content: "a";
    color: transparent;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 8px;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      to right,
      ${({ $percentage }) =>
        "#00C851 0%, #00C851 " +
        $percentage +
        "%, transparent " +
        $percentage +
        "%, transparent " +
        (100 - $percentage) +
        "%"}
    );
  }
`;

export const StyledCompletableTaskPopupText = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: teal;
  color: white;
  border-radius: 100%;
  padding: 5px;
  height: 30px;
  min-width: 30px;
  z-index: 2;
`;
